export const getFormattedShortLocalTime = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  return date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};
